import { useEffect, useState } from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Flex, Input, Text } from 'theme-ui';
import {
  setEmail,
  setLoginChildPageName,
  setMobileNo
} from '../../redux/feature/loginCredSlice';
import { sendOtp } from '../../redux/feature/authSlice';
import { constantLogin } from '../../constant/constant';
import { CLEVER_TAP_EVENTS } from '../../config/cleverTapEvents';
import { cleverTapEventPush } from '../../utils/cleverTap';
import { assetUrl, heroViredWebUrl } from '../../api/config';

const LoginHome = () => {
  const dispatch = useDispatch();
  const enteredMobile = useSelector((state) => state.loginCred.enteredMobile);
  const enteredEmail = useSelector((state) => state.loginCred.enteredEmail);
  const otp = useSelector((state) => state.auth.otp);

  const inputRef = useRef();
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    if (otp.sent) {
      const pageName =
        otp.authenticationType === 'email' ? 'emailOTPPage' : 'mobileOTPPage';
      dispatch(setLoginChildPageName(pageName));
    }
  }, [otp.sent]);

  const handleSendOTP = () => {
    const inputValue = inputRef.current.value;

    if (inputValue) {
      if (validateEmail(inputValue)) {
        dispatch(setEmail(inputValue));
        cleverTapEventPush(CLEVER_TAP_EVENTS.Login_Attempt, {
          Method_Used: 'Email OTP',
          Resend_OTP: false
        });
        dispatch(
          sendOtp({ value: inputValue, type: 'email', method: 'login' })
        );
      } else if (validatePhoneNo(inputValue)) {
        dispatch(setMobileNo(inputValue));
        console.log('Jhyg');
        cleverTapEventPush(CLEVER_TAP_EVENTS.Login_Attempt, {
          Method_Used: 'Mobile OTP',
          Resend_OTP: false
        });
        dispatch(
          sendOtp({ value: inputValue, type: 'phone', method: 'login' })
        );
      } else {
        setIsEmpty(true);
      }
    } else {
      setIsEmpty(true);
    }
  };

  const handleInputChange = () => {
    setIsEmpty(false);
    const inputValue = inputRef.current.value;
    if (validateEmail(inputValue)) {
      dispatch(setMobileNo(null));
    } else if (validatePhoneNo(inputValue)) {
      dispatch(setEmail(null));
    }
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const validatePhoneNo = (phone) => {
    return phone.toString().length === 10;
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      document.getElementById('send-opt-button').click();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <Box sx={{ fontSize: 3, width: '100%' }}>
      <Box className='login-label'>Mobile Number or Email ID</Box>
      <Input
        placeholder='Enter mobile number or email'
        onChange={handleInputChange}
        ref={inputRef}
        mt={2}
        type='text'
        className='login-input'
      />
      {otp.sendOtpError && (
        <Flex
          mt={2}
          sx={{
            width: '100%',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '12px',
            lineHeight: '20px',
            color: '#E34935',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }}
        >
          <Box className='error-text'>
            {otp.sendOtpError === "Email number doesn't exist in the system"
              ? 'This email address is not registered with us. Please try again'
              : otp.sendOtpError === 'service unavailable'
              ? 'This mobile number is not registered with us. Please try again'
              : otp.sendOtpError}
          </Box>
        </Flex>
      )}

      {isEmpty && (
        <Flex
          mt={2}
          sx={{
            width: '100%',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '12px',
            lineHeight: '20px',
            color: '#E34935',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }}
        >
          <Box className='error-text'>{constantLogin.emptyMessage}</Box>
        </Flex>
      )}
      <button
        onClick={handleSendOTP}
        mt={4}
        className='login-button'
        disabled={otp.sendOtpPending}
        id='send-opt-button'
      >
        Send OTP
      </button>
      <p
        onClick={() => {
          cleverTapEventPush(CLEVER_TAP_EVENTS.Login_Attempt, {
            Method_Used: 'Password',
            Resend_OTP: false
          });
          dispatch(setLoginChildPageName('emailPasswordHomePage'));
        }}
        className='login-link-button'
      >
        Proceed with email & password
      </p>
    </Box>
  );
};

export default LoginHome;
